<template>
  <div id="app">
    <!-- <img ref="myImg" alt="Vue logo" src="./assets/logo.png"> -->
    <MediaDevices msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import MediaDevices from './components/MediaDevices.vue'

export default {
  name: 'App',
  components: {
    MediaDevices
  },
  data(){
    return {
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
